import React from 'react';
import classnames from 'classnames';
import moment from 'moment';

import { Scrollbars } from 'react-custom-scrollbars';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import Pager from 'react-pager';

import style from './index.scss';

import { dateTimeFormat } from '../../../util/GlobalConstant';

const PastHitsTable = ({ data, isLoading }) => {
  if (data) {
    let loadingMessage = null;
    if (isLoading) {
      loadingMessage = (
        <tr>
          <td colSpan={6}>
            <h4>Loading past hits...</h4>
          </td>
        </tr>
      );
    }

    // loop every past hit returned, but check if it's an array first
    let formattedData = [];
    if (Array.isArray(data)) {
      data.forEach((currentData) => {
        formattedData.push(
          <tr>
            <td>{currentData['alertId']}</td>
            <td>{currentData['hitId']}</td>
            <td>{currentData['typeOfHit']}</td>
            <td>{currentData['nsHitInvestigatorName']}</td>
            <td>
              {currentData['nsHitClosureDate']
                ? moment
                    .utc(currentData['nsHitClosureDate'], [dateTimeFormat])
                    .local()
                    .format('DD/MM/YYYY')
                : '--'}
            </td>
            <td>{currentData['nsHitReasonDesc']}</td>
          </tr>
        );
      });
    }

    return (
      <table className="table">
        <thead>
          <tr>
            <th>Alert ID</th>
            <th>Hit ID</th>
            <th>Type</th>
            <th>Analyst Name</th>
            <th>Alert Close Date</th>
            <th>Alert Closure Reason</th>
          </tr>
        </thead>

        <tbody>
          {loadingMessage}
          {formattedData}
        </tbody>
      </table>
    );
  }

  return null;
};

const PastHitModal = (props) => {
  const {
    isLoading,
    pastHitModal = {},
    closePastHitModal,
    onPastHitsPageChange,
    data,
    pastHitsCount,
    offset
  } = props;

  return (
    <Modal
      size="lg"
      contentClassName={style.modalContainer}
      isOpen={pastHitModal?.isShown}
      toggle={() => {
        closePastHitModal();
      }}
      size="lg">
      <ModalBody>
        <div className="row">
          <div className="col-md-11">
            <p className={style.modalTitle}>Past Hits List</p>
            <p className={style.modalSubtitle}>
              WID -{' '}
              {pastHitModal?.data?.watchlistId
                ? pastHitModal.data.watchlistId
                : null}
            </p>
          </div>
          <div className="col-md-1">
            <a
              className={style.closeButton}
              href="javascript:void(0)"
              onClick={() => closePastHitModal()}>
              <p>
                <i className="fa fa-times"></i>
              </p>
            </a>
          </div>
        </div>

        <PastHitsTable data={data} isLoading={isLoading} />

        <div className="row">
          <div className="offset-md-4 col-md-4">
            <div style={{ marginLeft: '20%' }}>
              <Pager
                className={style.modalPager}
                titles={{ prev: '<', next: '>' }}
                total={Math.ceil(pastHitsCount / 5) || 0}
                current={offset}
                visiblePages={5}
                onPageChanged={onPastHitsPageChange}
              />
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default PastHitModal;
